<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.editexam") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.instructions_ar')"
            v-model.trim="data.instructions_ar"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.instructions_en')"
            v-model.trim="data.instructions_en"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.min_exam_pass_score')"
            v-model.trim="data.minimum_passing_score"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.exam_duration')"
            v-model.trim="data.duration"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FileUpload from "../../../components/formInputs/FileUpload.vue";

export default {
  name: "Editcourse-contents",
  components: { FileUpload },

  data() {
    return {
      isInitialCourseChange: true,
      isWaitingRequest: false,
      data: {
        name_ar: null,
        name_en: null,
        instructions_en: null,
        instructions_ar: null,
        duration: "",
        minimum_passing_score: "",
      

},
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    handleFileSelect(files) {
      this.selectedFiles = files;
    },

    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("type", "normal");

      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.duration) {
        REQUEST_DATA.append("duration", this.data.duration);
      }
      if (this.data.minimum_passing_score) {
        REQUEST_DATA.append(
          "minimum_passing_score",
          this.data.minimum_passing_score
        );
      }
      if (this.data.instructions_ar) {
        REQUEST_DATA.append("directions[ar]", this.data.instructions_ar);
      }
      if (this.data.instructions_en) {
        REQUEST_DATA.append("directions[en]", this.data.instructions_en);
      }

      REQUEST_DATA.append("_method", "PUT");
      try {
        await this.$axios({
          method: "POST",
          url: `exams/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/exams/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showExam() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `exams/${this.$route.params?.id}`,
        });
        this.data.name_ar = res.data.data.Exam.name_ar;
        this.data.name_en = res.data.data.Exam.name_en;

        this.data.instructions_ar = res.data.data.Exam.directions_ar;
        this.data.instructions_en = res.data.data.Exam.directions_en;
        this.data.minimum_passing_score =
          res.data.data.Exam.minimum_passing_score;
        this.data.duration = res.data.data.Exam.duration;
        this.data.active = res.data.data.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
  },

  created() {
    this.showExam();
  },
};
</script>
